import { render, staticRenderFns } from "./recibo-pagamento-empresas.vue?vue&type=template&id=7b91c64a&scoped=true&"
import script from "./recibo-pagamento-empresas.vue?vue&type=script&lang=js&"
export * from "./recibo-pagamento-empresas.vue?vue&type=script&lang=js&"
import style0 from "./recibo-pagamento-empresas.vue?vue&type=style&index=0&id=7b91c64a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b91c64a",
  null
  
)

export default component.exports